export default __webpack_public_path__ + "static/media/accounting_point_5.12b1fba3.png";